module.exports = __webpack_public_path__ + "img/5.3deb9df9.png";